Ext.define('SA.EditCrosstabMaximumAttributesRule', {
    constructor(model) {
        this.model = model;
    },

    getMessage() {
        return [
            'Your crosstab table contains too many data variables. The product of the number of columns ',
            'and number of rows in a crosstab cannot exceed 1,600. For example, your crosstab can have a ',
            'maximum of 40 columns × 40 rows, or 20 columns × 80 rows.'
        ].join('');
    },

    isBroken() {
        return this.model.hasTooManyAttributes();
    }
});